import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const HeaderRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 8px 16px;
    ${setFontVariant("captionTitle", colorsPalettes.carbon[300])}
`;

export const ValueRow = styled.span`
    display: inline-flex;
    gap: 8px;
`;

export const ClicksValue = styled.span`
    ${setFontVariant("body2", colorsPalettes.carbon[500])}
`;

export const PercentageValue = styled.span`
    ${setFontVariant("body2", colorsPalettes.carbon[300])}
`;

export const LocationPickerWrapper = styled.div<{ $hasValue: boolean }>`
    display: flex;
    flex-direction: column;
    flex: 1;

    .DropdownButton-country .country-text {
        color: ${({ $hasValue }) => ($hasValue ? colorsPalettes.carbon[400] : colorsPalettes.carbon[200])};
    }
`;
